import React, { useState } from 'react';
import { Grid, Typography, Box, Card, CardMedia, CardContent } from "@material-ui/core";
import styled from 'styled-components'
import ButtonAtom from '../../component/ButtonAtom/index.jsx'
import TextfieldAtom from '../../component/Textfield/index.jsx'
import { makeStyles } from '@material-ui/styles';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import Avatar from '@mui/material/Avatar';
import ReplyIcon from '@mui/icons-material/Reply';
import SliderOne from './../../img/download.png'
import ProductItem from './../../component/ProductItem/index'
import FooterBar from './../../component/FooterAtom/index'
import KeyboardDoubleArrowDownIcon from '@mui/icons-material/KeyboardDoubleArrowDown';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import ToggleOffIcon from '@mui/icons-material/ToggleOff';
import CallIcon from '@mui/icons-material/Call';
import Drawer from '@material-ui/core/Drawer';
import MobileBrowserMarketDrawer1 from './../../pages/Mobile_Browser_Market2/Mobile_Browser_Market2'
import OtpInput from "react-otp-input";
import NoFollowMeta from '../../component/NofollowMeta/index.jsx';

const Mobile_Browser_Market1 = (props) => {
  const classes = useStyles();

  const [Otp, setOtp] = useState("");
  const [show, setShow] = useState(false);
  const sentOtp = props.sentOtp;
  const number = props.number;

  const [state, setState] = React.useState({
    bottom: false,
  });


  const otpHandleChange = (otp) => {
    // const re = /^[0-9\b]+$/

    setOtp(otp);

  };
  const ValidateOtp = () => {
    if (Otp === null || sentOtp === null) return;
    sentOtp
      .confirm(Otp)
      .then((result) => {

        alert("OTP verified");
        setShow(true);
        // console.log(number);
      })
      .catch((err) => {
        alert("Wrong code");
      });
  };

  const toggleDrawer = (anchor, open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };
  return (
    <Grid p={2} className={classes.commonSectionBuild}>\
      <NoFollowMeta/>
      {/* <Box mt={4} ml={4}>
        <Typography variant="h6">कॉल करने के लिए अपना नंबर दर्ज़ करे </Typography>
      </Box>

      <Box>
        <Box mt={3} ml={2}>
          <Typography variant="body">अपना व्हाट्सप्प  नंबर दर्ज़ करे </Typography>
        </Box>

        <Box className={classes.headerBrowser2}>
          <WhatsAppIcon className={classes.headerBrowser3} />
          <TextfieldAtom placeholder="" />
        </Box>
        
        // <Box className={`${classes.otpBoxUi} ${classes.headerBrowser1} `}>
        //   <OtpInput
            numInputs={6}
            className={classes.otp}
            // keyboard-type='numeric'
            value={Otp}
            onChange={otpHandleChange}
            type="number"
            inputMode="numeric"
          />
          <Typography variant="body1" className={classes.punnCenter}><b>punn bheje</b></Typography>
        </Box>


        <Box className={classes.headerBrowser2}>
          <ToggleOffIcon />
          <Typography variant="caption" className={classes.textMiddleSet}>अपने व्हाट्सप्प पर इस और इसी तरह के सौदों पर अपडेट प्राप्त करे</Typography>
        </Box>
      </Box> 

      <Box className={classes.contetnArrange}>
        <Box mr={1} fullwidth>
          
          <ButtonAtom
            startIcon={<CallIcon />}
            name="कॉल करे "
          />
        </Box>
        <Box ml={1} fullwidth>
          {['bottom'].map((anchor) => (
            <ButtonAtom
              startIcon={<WhatsAppIcon />}
              name="व्हाट्सप्प करे "
              cclass="whatsUpBtn"
              onClick={toggleDrawer(anchor, true)}
            />
          ))}
        </Box>
      </Box>

      <div>
        {['bottom'].map((anchor) => (
          <React.Fragment key={anchor}>
            <Drawer className={classes.drawerDesign} anchor={anchor} open={state[anchor]} onClose={toggleDrawer(anchor, false)}>
              <MobileBrowserMarketDrawer1 />
            </Drawer>
          </React.Fragment>
        ))}
      </div> */}

      <Box className={`${classes.otpBoxUi} ${classes.headerBrowser1} `}>
        <Typography varient="h6">otp</Typography>
        <OtpInput
          numInputs={6}
          className={classes.otp}
          // keyboard-type='numeric'
          value={Otp}
          onChange={otpHandleChange}
          type="number"
          inputMode="numeric"
        />
        <Typography variant="body1" className={classes.punnCenter}><b>punn bheje</b></Typography>
      </Box>


    </Grid>

  )
};

const useStyles = makeStyles(() => ({
  drawerDesign: {
    '& .MuiDrawer-paper': {
      paddingTop: 20,
      borderRadius: '20px 20px 0 0',
    }
  },
  headerBrowser: {
    background: '#53252f',
    color: '#fff',
    display: 'flex',
    justifyContent: 'space-between',
    padding: '10px 20px',
    boxSizing: 'border-box',
    alignItems: 'center',
  },
  headerBrowser1: {
    background: '#fff',
    display: 'flex',
    justifyContent: 'space-between',
    padding: '10px 20px',
    boxSizing: 'border-box',
    alignItems: 'center',

  },
  kishanDetail: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '10px 20px',
    boxSizing: 'border-box',
    alignItems: 'center',
  },
  textCenterSet: {
    display: 'flex',
    alignItems: 'center',
  },
  rotateSHareIcon: {
    transform: 'rotateY(180deg)',
  },
  contetnArrange: {
    width: '100%',
    padding: '10px 20px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    boxSizing: 'border-box',
    '& div': {
      width: '100%'
    }
  },
  commonSectionBuild: {
    maxWidth: 540,
    float: 'none',
    margin: '0 auto'
  },
  manageIconCenter: {
    justifyContent: 'center',
    padding: '50px 0 20px',
    boxSizing: 'border-box',
  },
  headerBrowser2: {
    background: '#fff',
    color: 'black',
    display: 'flex',
    justifyContent: 'space-between',
    padding: '10px 20px',
    boxSizing: 'border-box',
    alignItems: 'center',
    position: 'relative',
    borderColor: '#53252f',
    '& input': {
      paddingLeft: 50,
    }

  },
  headerBrowser3: {
    position: 'absolute',
    top: 25,
    left: 30,
    color: '#53252f'

  },
  textMiddleSet: {
    marginRight: 140,
  },
  otpBoxUi: {
    justifyContent: 'center',
    margin: '30px 0',
  },
  otp: {
    size: 16,
    margin: 'auto 5px',
    '& input': {
      width: '36px !important',
      minHeight: 50,
      border: '0 !important',
      background: 'rgba(83, 37, 47, 0.05)',
      borderRadius: 4,
      color: '#000',
    }
  },
  punnCenter: {
    marginLeft: '20px',
    marginTop: '25px',
  }

}));


export default Mobile_Browser_Market1;

